<template>
    <div>
		<fieldset>
			<legend>Informações Cadastradas</legend>
			<div class="row">
				<div class="col s3">
					<label style="font-size: 18px" name="memorial-label"
						>PDF do Memorial:</label
					>
					<a
						:href="`/projetos/${this.project.id}/memorialDownload`"
						id="pdf-memorial-a"
						target="_blank"
					>
						<i class="material-icons">vertical_align_bottom</i>
					</a>
				</div>
			</div>
			<fieldset>
				<legend>Atuação Indicada pelo Proponente</legend>
				<div class="row centered">
					<table class="table-responsive highlight striped "> 
						<col width="5%">
						<col width="50%">
						<col width="20%">
						<col width="20%">
						<col width="5%">
						<thead>
							<th></th>
							<th>Tipo de Atuação</th>
							<th>Quantidade</th>
							<th>PDF</th>
							<th></th>
						</thead> 
						<tbody> 
							<tr v-for="(atuacao, index) in project.curriculo.atuacoes"  v-if="atuacao.atuacao.tipo == 'artístico-cultural'">	
								<td></td>
								<td>{{atuacao.atuacao['nome']}}</td>
								<td>{{atuacao['quantidade']}}</td>
								<td v-if="atuacao['pdf']">
									<a :href="'/curriculos/atuacoes/pdf/' + atuacao['id']" class="btn" target='_blank'>
										<i class="material-icons left">assignment_returned</i>Visualizar PDF
									</a>
								</td>
								<td></td>
							</tr>
						</tbody>
					</table>
				</div>
			</fieldset>
		</fieldset>
       
		<fieldset>
			<legend>Avaliação do Memorial</legend>
			<div class="row">
				<div class="col s8">
					<label id="artistico-ou-tecnico-label" for="tecnico-radiobutton"
						>Esse Memorial é artístico ou técnico?</label
					>
					<label>
						<input
							type="radio"
							id="tecnico-radiobutton"
							name="grupo-artistico-cultural"
							value="tecnico"
							v-model="optionSelected"
						/>
						<span>Técnico</span>
					</label>
					<label>
						<input
							type="radio"
							id="artistico-radiobutton"
							name="grupo-artistico-cultural"
							value="artistico"
							v-model="optionSelected"
						/>
						<span>Artístico</span>
					</label>
				</div>
			</div>
			<div class="row ">
				<div
					class="col s12"
					v-if="
						optionSelected == 'artistico' &&
							itensArtistico &&
							itensArtistico.length
					"
				>
					<avaliacao-artistico-cultural-opcao-artistico
						:itens="itensArtistico"
					/>
				</div>
				<div
					class="col s12"
					v-if="
						optionSelected == 'tecnico' &&
							itensTecnico &&
							itensTecnico.length
					"
				>
					<avaliacao-artistico-cultural-opcao-tecnico
						:itens="itensTecnico"
					/>
				</div>
			</div>
		</fieldset><br>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import AvaliacaoArtisticoCulturalOpcaoArtistico from "./AvaliacaoArtisticoCulturalOpcaoArtistico.vue";
import AvaliacaoArtisticoCulturalOpcaoTecnico from "./AvaliacaoArtisticoCulturalOpcaoTecnico.vue";
export default {
    name: "AvaliacaoArtisticoCultural",
    data() {
        return { optionSelected: "" };
    },
    components: {
        AvaliacaoArtisticoCulturalOpcaoArtistico,
        AvaliacaoArtisticoCulturalOpcaoTecnico
    },
    asyncComputed: {
        async itensArtisticoCultural() {
            try {
                let { data } = await this.$http.get(
                    "/api/itensArtisticoCultural"
                );
                return data;
            } catch (error) {
                console.log(error);
            }
        },
        async itensTecnico() {
            try {
                let itens = await this.itensArtisticoCultural;
                if (itens && itens.length)
                    return itens.filter(e => e.grupo == "Aspectos Técnicos");
            } catch (error) {
                console.error(error);
            }
        }
    },
    computed: {
        ...mapState(["project"]),
        itensArtistico() {
            try {
                return this.itensArtisticoCultural.filter(
                    e => e.grupo == "Aspectos Artísticos"
                );
            } catch (error) {
                console.error(error);
            }
        }
    },
    watch: {
        itensArtisticoCultural: function(newValue, oldValue) {
            this.itensTecnico;
        }
    },
    methods: {
        ...mapActions(["setAvaliacaoArtisticoCultural"]),
        async getAvaliacaoArtisticoCultural() {
            try {
                let { data } = await this.$http.get(
                    `/api/avaliacaoArtisticoCultural/${this.project.avaliacao.id}`
                );

                if (data[0] != null) {
                    this.setAvaliacaoArtisticoCultural(JSON.parse(data));
                    if (
                        this.project.avaliacao.avaliacao_artistico_cultural
                            .artistico != undefined
                    ) {
                        this.$set(this, "optionSelected", "artistico");
                    } else {
                        this.$set(this, "optionSelected", "tecnico");
                    }
                }
            } catch (error) {
                console.error(error);
            }
        }
    },
    mounted() {
        if (this.$http) this.getAvaliacaoArtisticoCultural();
    }
};
</script>
